"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FutureBillsState = /** @class */ (function () {
    function FutureBillsState() {
        this.showFutureBillsModal = false;
        this.isRepError = false;
        this.isBundle = false;
        this.isLoading = false;
        this.isHsiaInstantOn = false;
    }
    return FutureBillsState;
}());
exports.default = FutureBillsState;
//# sourceMappingURL=FutureBillsState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/FutureBills/FutureBillsState.js
// module id = 2332
// module chunks = 8